export const environment = {
    production: false,
    currentData: 'https://t2-results-display-current-dev.ecsa.sa.gov.au/',
    appInsights: {
        instrumentationKey: '16356126-dba5-4ef9-ae65-10166b86e5a8'
    },
    isMock: false
};
